let isPatched = false;

const sanitizeDabeeoMapsImageUrl = (value: string) => {
    if (!value.startsWith('data:') && !value.startsWith('blob:')) {
        return value;
    }

    const queryIndex = value.indexOf('?');
    if (queryIndex === -1) {
        return value;
    }

    return value.slice(0, queryIndex);
};

export const patchDabeeoMapsImageLoaderUrl = () => {
    if (isPatched || typeof window === 'undefined') {
        return;
    }

    isPatched = true;

    const srcDescriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    if (srcDescriptor?.set) {
        Object.defineProperty(HTMLImageElement.prototype, 'src', {
            ...srcDescriptor,
            set(value) {
                const nextValue = typeof value === 'string' ? sanitizeDabeeoMapsImageUrl(value) : value;
                srcDescriptor.set!.call(this, nextValue);
            },
        });
    }

    const originalSetAttribute = HTMLImageElement.prototype.setAttribute;
    HTMLImageElement.prototype.setAttribute = function setAttribute(name, value) {
        if (name === 'src' && typeof value === 'string') {
            return originalSetAttribute.call(this, name, sanitizeDabeeoMapsImageUrl(value));
        }

        return originalSetAttribute.call(this, name, value);
    };
};
